import compact from "lodash/compact";

export const lastNameWithInitials = ({
    firstName,
    lastName,
    patronymic,
}: {
    firstName: string;
    lastName: string;
    patronymic: string;
}) => {
    const firstChar = (item: string) => (item ? `${item.charAt(0)}.` : "");
    return `${lastName} ${firstChar(firstName)}${firstChar(patronymic)}`.trim();
};

export const fullName = ({
    firstName,
    lastName,
    patronymic,
}: {
    firstName: string;
    lastName: string;
    patronymic: string;
}) => {
    return compact([lastName, firstName, patronymic]).join(" ");
};
